import { UniqueIdentifier } from '@dnd-kit/core';
import { arrayMove } from '@dnd-kit/sortable';
import { unstable_batchedUpdates } from 'react-dom';
import { ItemsI } from '../types';
import { findContainerId } from './findContainerId';
import { getNextContainerId } from './getNextContainerId';
import { Dispatch } from 'react';

export const PLACEHOLDER_ID = 'placeholder';

/**
 * OnDragEnd.
 */
export const onDragEnd = ({
  overId,
  activeId,
  setContainers,
  items,
  setActiveId,
  setItems,
}: {
  overId: UniqueIdentifier;
  items: ItemsI;
  setItems: (value: React.SetStateAction<ItemsI>) => void;
  setActiveId: Dispatch<React.SetStateAction<UniqueIdentifier | null>>;
  setContainers: (value: React.SetStateAction<UniqueIdentifier[]>) => void;
  activeId: UniqueIdentifier;
}) => {
  if (activeId in items) {
    setContainers((containers) => {
      const activeIndex = containers.indexOf(activeId);
      const overIndex = containers.indexOf(overId);

      return arrayMove(containers, activeIndex, overIndex);
    });
  }

  const activeContainer = findContainerId(activeId, items) as any; // FIXME: any

  if (overId === PLACEHOLDER_ID) {
    const newContainerId = getNextContainerId(items);

    unstable_batchedUpdates(() => {
      setContainers((containers) => [...containers, newContainerId]);
      setItems((items) => ({
        ...items,
        [activeContainer]: items[activeContainer].filter(
          (id) => id !== activeId,
        ),
        [newContainerId]: [activeId],
      }));
      setActiveId(null);
    });
  } else {
    const overContainer = findContainerId(overId, items) as any; // FIXME: any
    const activeIndex = items[activeContainer].indexOf(activeId);
    const overIndex = items[overContainer].indexOf(overId);

    if (activeIndex !== overIndex) {
      setItems((items) => ({
        ...items,
        [overContainer]: arrayMove(
          items[overContainer],
          activeIndex,
          overIndex,
        ),
      }));
    }

    setActiveId(null);
  }
};
